import axios from 'axios'

export function getCampaigns (context) {
  const url = this.$config.panoramas.api
  const config = {
    headers: context.rootGetters['auth/headers']
  }
  axios.get(url, config)
    .then(response => {
      if (response.data && response.data.count > 0) {
        context.commit('setCampaigns', response.data.results)
        context.dispatch('selectCampaign', response.data.results[0])
      }
    })
}

export function getPanoByPoint (context, latLng) {
  context.commit('errorFetching', false)
  context.commit('loading', true)

  if (!context.state.selectedCampaign) {
    const url = this.$config.panoramas.api
    const config = {
      headers: context.rootGetters['auth/headers']
    }
    axios.get(url, config)
      .then(response => {
        if (response.data && response.data.count > 0) {
          context.commit('setCampaigns', response.data.results)
          context.dispatch('selectCampaign', response.data.results[0])
        }
      })
      .then(() => {
        _getPanoByPoint(context, this.$config, latLng)
      })
  } else {
    _getPanoByPoint(context, this.$config, latLng)
  }
}
export function selectCampaign (context, selectedCampaign) {
  context.commit('setSelectedCampaign', selectedCampaign)

  const folderPanorama = _formatFoldersCampaign(selectedCampaign.folder_panorama, this.$config)
  context.commit('setFolderPanoramaCampaign', folderPanorama)
  const folderLaterals = _formatFoldersCampaign(selectedCampaign.folder_images, this.$config)
  context.commit('setFolderLateralsCampaign', folderLaterals)
  const folderPointCloud = _formatFoldersCampaign(selectedCampaign.folder_point_cloud, this.$config)
  context.commit('setFolderPointCloudCampaign', folderPointCloud)
}

function _formatFoldersCampaign (folder, $config) {
  if (!folder) {
    return $config.panoramas.media
  }

  if (!folder.endsWith('/')) {
    folder = folder + '/'
  }
  if (!folder.startsWith('https')) {
    folder = $config.panoramas.media + folder
  }
  return folder
}

function _getPanoByPoint (context, $config, latLng) {
  const url = $config.panoramas.api + context.state.selectedCampaign.code + '/panoramas/'
  let config = {
    params: {
      p: `${latLng.lat},${latLng.lng}`,
      r: $config.panoramas.radius
    },
    headers: context.rootGetters['auth/headers']
  }
  if (context.state.selectedCategory) {
    config.params['c'] = context.state.selectedCategory.code
  }
  axios.get(url, config)
    .then(response => {
      if (response.data && response.data.length > 0) {
        context.commit('setResult', response.data)
        const panorama = response.data[0]
        context.commit('setNeighbours', response.data.splice(1))
        context.dispatch('setPanorama', panorama)
      // } else {
      //   context.dispatch('resetPanorama')
      }
    })
    .catch(() => {
      context.commit('errorFetching', true)
    }).then(() => {
      context.dispatch('setSrcPannellum')
      context.dispatch('setSrcPotree')
      context.commit('loading', false)
    })
}

export function setPanorama (context, panorama) {
  context.commit('setAltitude', panorama.altitude)
  const latLng = {
    lat: panorama.geom.coordinates[1],
    lng: panorama.geom.coordinates[0]
  }
  context.commit('setLatLng', latLng)
  context.commit('setName', panorama.file_name)
  context.commit('setDate', panorama.date)
  context.commit('setPan', panorama.pan)
  context.commit('setPitch', panorama.pitch)
  context.commit('setRoll', panorama.roll)
  context.commit('setLaterals', panorama.laterals)

  let folder = panorama.file_folder
  if (folder) {
    if (!folder.endsWith('/')) {
      folder = folder + '/'
    }
    if (!folder.startsWith('https')) {
      folder = context.state.folderPanoramaCampaign + folder
    }
  } else {
    folder = context.state.folderPanoramaCampaign
  }
  context.commit('setFolderPanorama', folder)
  // TO DO
  // pointcloud folder
}

export function resetPanorama (context) {
  context.commit('setNeighbours', null)
  context.commit('setAltitude', null)
  context.commit('setLatLng', null)
  context.commit('setName', '')
  context.commit('setDate', '')
  context.commit('setPan', null)
  context.commit('setPitch', null)
  context.commit('setRoll', null)
  context.commit('setLaterals', null)
}

export function setSrcPannellum (context) {
  if (!context.state.name || context.state.name === '') {
    context.state.srcPannellum = this.$config.panoramas.noImage
  } else {
    let params = '?name=' + context.state.folderPanorama + context.state.name +
      `&center=${context.state.latLng.lat},${context.state.latLng.lng},${context.state.altitude}` +
      `&head=${90 - context.state.pan - context.state.head}` +
      `&azimut=${context.state.pan}` +
      `&pitch=${context.state.pitch}` +
      `&roll=${context.state.roll}` +
      `&date=${context.state.date}` +
      `&access_token=${context.rootState.auth.accessToken}`
    if (context.state.screenshot) {
      params += `&screenshot=${context.state.screenshot}`
    }
    if (context.state.neighbours) {
      const pointNeighbours = context.state.neighbours.map(neighbour => {
        const coords = [...neighbour.geom.coordinates]
        const point = [...coords.reverse(), neighbour.altitude]
        return point.join(',')
      }).join('|')
      params += `&near=${pointNeighbours}`
    }
    context.state.srcPannellum = this.$config.panoramas.pannellum + params
  }
}

export function setSrcLateral (context) {
  if (context.state.selectedLateral) {
    let folderLateral = context.state.selectedLateral.file_folder
    if (folderLateral) {
      if (!folderLateral.endsWith('/')) {
        folderLateral = folderLateral + '/'
      }
      if (!folderLateral.startsWith('https')) {
        folderLateral = context.state.folderLateralsCampaign + folderLateral
      }
    }
    context.state.srcLateral = folderLateral + context.state.selectedLateral.file_name + `?access_token=${context.rootState.auth.accessToken}`
  }
}

export function setSrcPotree (context) {
  if (!context.state.srcPotree) {
    context.state.srcPotree = this.$config.panoramas.potree + `?access_token=${context.rootState.auth.accessToken}`
  }
  const iframe = window.frames['mapiaPointCloud']
  if (iframe && iframe.mapiaPotree) {
    const neighbours = context.state.neighbours.map(neighbour => {
      const coords = [...neighbour.geom.coordinates]
      return [...coords.reverse(), neighbour.altitude]
    })
    const panoConfig = {
      name: context.state.folderPanorama + context.state.name,
      center: [context.state.latLng.lat, context.state.latLng.lng, context.state.altitude],
      head: 90 - context.state.pan - context.state.head,
      azimut: context.state.pan,
      pitch: context.state.pitch,
      roll: context.state.roll,
      date: context.state.date,
      neighbours
    }
    iframe.mapiaPotree.setOption('panoConfig', panoConfig)
  }
}

export function getPreviousPano (context) {
  const currentPanorama = context.state.result[0]
  const neighbours = context.state.neighbours.filter(panorama => {
    return panorama.source_id < currentPanorama.source_id
  })
  const neighboursDifference = neighbours.map(neighbour => {
    return Math.abs(currentPanorama.source_id - neighbour.source_id)
  })
  if (Math.min(...neighboursDifference) > 10) {
    return
  }
  const prevIndex = neighboursDifference.indexOf(
    Math.min(...neighboursDifference)
  )
  const latLng = {
    lat: neighbours[prevIndex].geom.coordinates[1],
    lng: neighbours[prevIndex].geom.coordinates[0]
  }
  context.dispatch('getPanoByPoint', latLng)
}

export function getNextPano (context) {
  const currentPanorama = context.state.result[0]
  const neighbours = context.state.neighbours.filter(panorama => {
    return panorama.source_id > currentPanorama.source_id
  })
  const neighboursDifference = neighbours.map(neighbour => {
    return Math.abs(currentPanorama.source_id - neighbour.source_id)
  })
  if (Math.min(...neighboursDifference) > 10) {
    return
  }
  const prevIndex = neighboursDifference.indexOf(
    Math.min(...neighboursDifference)
  )
  const latLng = {
    lat: neighbours[prevIndex].geom.coordinates[1],
    lng: neighbours[prevIndex].geom.coordinates[0]
  }
  context.dispatch('getPanoByPoint', latLng)
}

export function selectLateral (context) {
  let head = 90 - context.state.head
  if (head < 0) {
    head += 360
  }
  const laterals = context.state.laterals
  if (laterals) {
    const selectedLateral = laterals.slice(1).reduce((selectedLateral, newLateral) => {
      selectedLateral.pan = selectedLateral.pan < 0 ? selectedLateral.pan + 360 : selectedLateral.pan
      let diffSelectedLateral = Math.abs(selectedLateral.pan - head)
      if (diffSelectedLateral > 360) {
        diffSelectedLateral -= 360
      }
      newLateral.pan = newLateral.pan < 0 ? newLateral.pan + 360 : newLateral.pan
      let diffNewLateral = Math.abs(newLateral.pan - head)
      if (diffNewLateral > 360) {
        diffNewLateral -= 360
      }
      if (diffNewLateral < diffSelectedLateral) {
        return newLateral
      } else {
        return selectedLateral
      }
    }, laterals[0])
    context.commit('setSelectedLateral', selectedLateral)
    context.dispatch('setSrcLateral')
  }
}
